import { API_URL } from "../constants";

class FileZipService {
    async download(filename, images) {
        try {
            const response = await fetch(`${API_URL}/download-images`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                    // 'x-authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ images: images }),
            });

            if (!response.ok) {
                throw new Error("Failed to download images");
            }

            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `${filename}.zip`;
            link.click();

            return { success: true, message: 'File has been downloaded' }

        } catch (error) {
            console.error("Error downloading images:", error);
            return { success: false, message: "Error downloading images:" + error }
        }
    }
}

const fileZipService = new FileZipService();
export default fileZipService;
